import tabNavigation from '../../../../../../src24/js/modules/tabNavigation';
import sliderTabNavigation from '../../../../../../src24/js/modules/sliderTabNavigation';

window.addEventListener('load', () => {
    tabNavigation.init();
    sliderTabNavigation.init();
});
